import { StateCreator } from "zustand";
import { Store } from "./types";
import { fetchConfig as fetchConfigAPI } from "@/lib/api/config";

export const createConfigSlice: StateCreator<
  Store,
  [],
  [],
  Pick<Store, "config" | "setConfig" | "fetchConfig">
> = (set) => ({
  config: null,
  setConfig: (config) => set({ config }),
  fetchConfig: async () => {
    // Caught, deliberately. Callers fire this and do not await it — the three
    // gates call it from an effect — so a rejection here had nowhere to go and
    // surfaced as an unhandled rejection, which fails the whole vitest run even
    // when every test passes. It also meant a `/config` that 500s or a token that
    // is refused took the app down by way of a promise nobody was holding.
    //
    // Leaving `config` null is the right failure: every consumer already reads it
    // through `config?.`, so the UI degrades to its defaults rather than breaking.
    try {
      const config = await fetchConfigAPI();
      set({ config });
    } catch (error) {
      console.error("Failed to fetch config", error);
    }
  },
});
